import actions from '../../actionTypes';

export default location => {
  return {
    type: actions.SET_CURRENT_LOCATION,
    location
  };
};



// WEBPACK FOOTER //
// ./src/reducers/locations/actions/setCurrentLocation.js